import {Injectable} from '@angular/core';
import {ApiService} from '~/app/core/common/services/api.service';
import { HttpClient } from '@angular/common/http';
import {ReportColumnTitles} from '~/app/core/common/models/ReportColumnTitles';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {Categories} from '~/app/core/common/models/catigories';

import {ProfileItemInsert} from '~/app/core/common/models/profileItemInsert';
import {ProfileItem} from '~/app/core/common/models/profileItem';
import {ProfileItemUpdated} from '~/app/core/common/models/profileItemUpdated';
import {ProfileItemInsertUpdated} from '~/app/core/common/models/profileItemInsertUpdated';
import {DialogHelperComponent} from '~/app/shared/helpers/dialog-helper';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {ProfileCategoriesService} from '~/app/core/common/services/profile-categories.service';
import {CategoryItem} from '~/app/core/common/models/categoryItem';
import {Router} from '@angular/router';
import {orderBy} from '@progress/kendo-data-query';
import {BaseService} from '~/app/core/common/services/base.service';
import {GoogleAnalyticsService} from '~/app/core/common/services/google-analytics.service';
import {Nomenclatures} from '~/app/core/common/enums/Nomenclatures';
import {InternetConnectionService} from '~/app/shared/services/internet-connection.service';
import {ErrorApiService} from '~/app/core/common/test/error-api.service';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import { ToastService } from '~/app/shared/helpers/toast-service';

@Injectable({
    providedIn: 'root'
})

export class ProfileService extends BaseService {
    public tabs: Array<any>;
    public titles: Array<any>;
    public selectedIndex = 0;
    public itemsSaved = false;
    private _profileItemsURL: string;
    private _recordCount = 0;
    private _profileItemArray: ProfileItem[];
    private _profileItemListViewArray: ProfileItem[];
    private _categoryArray = [];
    private _profileItem: ProfileItemInsert;
    private _selectedCategory: string;
    private _selectedItem: ProfileItem;
    private _processing = false;

    constructor(public http: HttpClient,
                public apiService: ApiService,
                private _storeListService: StoreListService,
                public internetConnectionService: InternetConnectionService,
                private router: Router,
                private _profileCategoriesService: ProfileCategoriesService,
                private _dialogHelper: DialogHelperComponent,
                public googleAnalyticsService: GoogleAnalyticsService,
                public errorApiService: ErrorApiService,
                public applicationSettingsHelper: ApplicationSettingsHelper,
                public baseService:BaseService,
                private toaster:ToastService
                ) {
        super(http,
            googleAnalyticsService,
            internetConnectionService,
            errorApiService,
            applicationSettingsHelper);
        this.titles = ReportColumnTitles.PROFILE_TAB_TITLES;
        this.tabs = [];
        this.itemsSaved = false;
        // this.selectedIndex = +this._applicationSettingsHelper.getSelectedProfileTab();
    }

    get tabsList(): Array<any> {
        return this.tabs;
    }

    get recordCount(): number {
        return this._recordCount;
    }

    set recordCount(value: number) {
        this._recordCount = value;
    }

    get profileItemArray(): ProfileItem[] {
        return this._profileItemArray;
    }

    set profileItemArray(value: ProfileItem[]) {
        this._profileItemArray = value;
    }

    get profileItemListViewArray(): ProfileItem[] {
        return this._profileItemListViewArray;
    }

    set profileItemListViewArray(value: ProfileItem[]) {
        this.recordCount = value.length;
        this._profileItemListViewArray = value;
    }

    get categoryArray(): any[] {
        return this._categoryArray;
    }

    set categoryArray(value: any[]) {
        this._categoryArray = value;
    }

    get profileItem(): ProfileItemInsert {
        return this._profileItem;
    }

    set profileItem(value: ProfileItemInsert) {
        this._profileItem = value;
    }

    get selectedCategory(): string {
        return this._selectedCategory;
    }

    set selectedCategory(value: string) {
        this._selectedCategory = value;
    }

    get selectedItem(): ProfileItem {
        return this._selectedItem;
    }

    set selectedItem(value: ProfileItem) {
        this._selectedItem = value;
    }

    get processing(): boolean {
        return this._processing;
    }

    set processing(value: boolean) {
        this._processing = value;
    }

    async downloadProfileItems(customer_number: string, status: string): Promise<ProfileItemInsert> {
        // this.selectedIndex = 0; // TODO app crashes without this - ezrusse

        return this.profileItem = await this.callProfileItems(customer_number, status).then((result) => {
            this.profileItem = result;
            this.initializeProfileItems();
            return this.profileItem;
        });
    }

    initializeProfileItems() {
        this.profileItem.items.forEach(item => {
            item.hasError = false;
            item.updated = false;
            item.categoryItemAdd = false;
            item.categoryItemRemove = false;
            item.documentType = 'profile_item';
        });
        // TODO leaving this for mobile
        this.profileItemArray = this.sortProfileItems(this.profileItem.items);
        this.profileItem.items = this.sortProfileItems(this.profileItem.items);
        this.categoryArray = this.getItemCategories(this.profileItem.items);
        this.profileItemListViewArray = this.profileItem.items.filter(category => {
            if (category.categoryDescription === 'ALL ITEMS') {
                return category;
            }
        });
        this.recordCount = this.profileItemListViewArray.length;
        this.profileItemListViewArray.sort((a, b) => 0 - (a.sequence > b.sequence ? -1 : 1));
        this.selectedItem = this.profileItemListViewArray[0];
    }

    // Run to sort all items at beginning, Still needs to be called after each sequence change
    sortProfileItems(items: ProfileItem[]) {
        return orderBy(items, [{field: 'sequence', dir: 'asc'}]);
    }

    // Filter Full Item List
    filterItemsByCategory() {
        if (
            //(this._profileCategoriesService.selectedCategory.description === 'CRITICAL ITEMS')|| 
            (this._profileCategoriesService.selectedCategory.description === 'HOLD ITEMS')) {
            return this.profileItem.items.filter(category => 'ALL ITEMS' === category.categoryDescription && category.categoryItemRemove === false);
        } else if(this._profileCategoriesService.selectedCategory.description === 'CRITICAL ITEMS'){
            return this.profileItem.items.filter(category => 'ALL ITEMS' === category.categoryDescription 
            && category.categoryItemRemove === false && category.critical);
            
        }
        else {
            return this.profileItem.items.filter(category => this._profileCategoriesService.selectedCategory.description === category.categoryDescription && category.categoryItemRemove === false);
        }
    }

    async callProfileItems(customer_number: string, status: string) {
        this._profileItemsURL = this.apiService.profileBulkItemsURL
            .replace('customer_number', customer_number)
            .replace('item_status', status);
        const results = await this.getHttp(
            'callProfileItems',
            'profile-service', this._profileItemsURL)
            .toPromise();
        return results as ProfileItemInsert;
    }

    public getProfileItems(profileItem: ProfileItemInsert) {
        const jsonItem = JSON.stringify(profileItem);
        return this.postHttpJson(
            'getProfileItems',
            'profile-service',
            this.apiService.saveProfileItemsURL, jsonItem)
            .pipe(catchError(error => of(error)));
    }

    public saveProfileItems(profileItem: ProfileItemInsertUpdated) {
        const jsonItem = JSON.stringify(profileItem);
        return this.postHttpJson(
            'saveProfileItems',
            'profile-service',
            this.apiService.saveProfileItemsURL, jsonItem)
            .pipe(catchError(error => of(error)));
    }

    saveCategories(categoryItem: CategoryItem[]) {
        const jsonItem = JSON.stringify(categoryItem);
        return this.postHttpJson(
            'saveCategories',
            'profile-service',
            this.apiService.profileAddBulkItemCategoryURL, jsonItem)
            .pipe(catchError(error => of(error)));
    }

    removeCategories(categoryItem: CategoryItem[]) {
        const jsonItem = JSON.stringify(categoryItem);
        return this.postHttpJson(
            'removeCategories',
            'profile-service',
            this.apiService.profileRemoveBulkItemCategoryURL, jsonItem)
            .pipe(catchError(error => of(error)));
    }

    async onTabSelect(e) {
        this.selectedIndex = e.index;
    }

    getItemCategories(items: ProfileItem[]): object[] {
        const categoryArray = new Array<Categories>();
        items.map((value) => {
            const category = value.categoryDescription;
            if (category !== null && category !== undefined) {
                if (categoryArray.filter(item => item.category === category).length < 1) {
                    if (category === 'ALL ITEMS') {
                        categoryArray.push({category: category, isEnabled: true});
                    } else {
                        categoryArray.push({category: category, isEnabled: false});
                    }
                }
            }
        });
        return categoryArray;
    }

    async saveAllItems() {
        if (this.internetConnectionService.isEnabled) {
            let result: boolean;
            result = await this._dialogHelper
                .showConfirmDialogYesNo(Nomenclatures.DIALOG_SAVE_PROFILE_ITEMS,
                    Nomenclatures.DIALOG_SAVE_PROFILE_ITEMS_MSG);
            if (result) {
                this.processing = true;
                this.applicationSettingsHelper.setProfileCategoryChangesSaved(false);
                let itemSafe: ProfileItemInsert;
                itemSafe = this.buildSaveItemArray();
                await this.getProfileItems(itemSafe).toPromise().then(async () => {
                    this.toaster.showToastInfo(Nomenclatures.SAVE_SUCCESSFUL, '', +Nomenclatures.TIMEOUT5000);
                    this.resetUpdatedProperties();
                    await this.saveAllCategories();
                    await this.deleteAllCategories().then(async () => {
                        const pickedCustomerId = await this._storeListService.pickedCustomerIdVerify();
                        await this.downloadProfileItems(pickedCustomerId.toString(), 'A');
                    });

                });
                this.processing = false;
            }
        } else {
            await this._dialogHelper.showConfirmDialogOkOnly('Offline Mode', 'Changes will be saved on device until internet connection is re-established.');
            this.toaster.showToastError(Nomenclatures.NO_INTERNET_CONNECTION, Nomenclatures.ERROR, +Nomenclatures.TIMEOUT4000);
        }
    }

    async saveAllCategories() {
        const itemSafe = this.buildCategoryItemForSave();
        await this.saveCategories(itemSafe).toPromise().then(() => {
            // this.resetUpdatedCategoryProperties(); // TODO this is now only called in the delete all
        });
    }

    async deleteAllCategories() {
        const itemSafe = this.buildCategoryItemForDelete();
        await this.removeCategories(itemSafe).toPromise().then(() => {
            this.resetUpdatedCategoryProperties();
        });
    }

    buildCategoryItemForSave() {
        let x: number;
        let categoryItem: CategoryItem;
        const profileItemsToAdd = this.profileItem.items.filter((value) => value.categoryItemAdd);
        const categoriesToSave: CategoryItem[] = [];
        for (x = 0; x < profileItemsToAdd.length; x++) {
            categoryItem = new CategoryItem();
            categoryItem.categoryId = profileItemsToAdd[x].categoryId;
            categoryItem.customerItemId = profileItemsToAdd[x].customerItemId;
            categoriesToSave.push(categoryItem);
        }
        return categoriesToSave;
    }

    buildCategoryItemForDelete() {
        let y: number;
        let categoryItem: CategoryItem;
        const profileItemsToRemove = this.profileItem.items.filter((value) => value.categoryItemRemove);
        const categoriesToDelete: CategoryItem[] = [];
        for (y = 0; y < profileItemsToRemove.length; y++) {
            categoryItem = new CategoryItem();
            categoryItem.categoryId = profileItemsToRemove[y].categoryId;
            categoryItem.customerItemId = profileItemsToRemove[y].customerItemId;
            categoriesToDelete.push(categoryItem);
        }
        return categoriesToDelete;
    }

    resetUpdatedCategoryProperties() {
        this.profileItem.items.map(value => {
            value.categoryItemAdd = false;
            value.categoryItemRemove = false;
        });
        this.itemsSaved = false;
    }

    resetUpdatedProperties() {
        this.profileItem.items.map(value => {
            value.updated = false;
        });
        this.itemsSaved = false;
    }

    updateProfileItemListView() {
        this.profileItemListViewArray = this.profileItem.items.filter(item => {
            if (item.categoryDescription === this._profileCategoriesService.selectedCategory.description && item.categoryItemRemove === false) {
                return item;
            }
        });
        this.profileItemListViewArray.sort((a, b) => 0 - (a.sequence > b.sequence ? -1 : 1));
        this.selectedItem = this.profileItemListViewArray[0];
    }

    convertProfileItemToSave(profileItem: ProfileItem): ProfileItemUpdated {
        return {
            show: profileItem.show,
            critical: profileItem.critical,
            ledgerCode: profileItem.ledgerCode,
            customerItemId: profileItem.customerItemId,
            customerItem: profileItem.customerItem,
            description: profileItem.description,
            uom: profileItem.uom,
            categoryDescription: profileItem.categoryDescription,
            categoryId: profileItem.categoryId,
            locationIds: profileItem.locationIds,
            inventoryFrequency: profileItem.inventoryFrequency,
            maxQty: profileItem.maxQty,
            buildToQty: profileItem.buildToQty,
            sequence: profileItem.sequence,
        };
    }

    private buildSaveItemArray() {
        let x: number;
        let profileSave: ProfileItemInsert;
        const profileItems = this.profileItem.items.filter((value) => value.updated);
        const itemsToSave = [];
        for (x = 0; x < profileItems.length; x++) {
            itemsToSave.push(this.convertProfileItemToSave(profileItems[x]));
        }
        profileSave = new ProfileItemInsert();
        profileSave.userName = this.applicationSettingsHelper.getPreferredUserName() != null ? this.applicationSettingsHelper.getPreferredUserName()  : 'N/A';
        profileSave.customerId = this._storeListService.pickedCustomerId;
        profileSave.items = itemsToSave;
        return profileSave;
    }

    public getStoreLogins(custId: string) {
        return this.baseService.getHttpObject<any>(
            'getStoreLogins',
            'profile-service',
            this.apiService.getStoreLoginURL.replace('customer_number', custId));
      }
}
